// extracted by mini-css-extract-plugin
export default {"container":"Section_container__YjuGC","title":"Section_title__lZyfT"};